import React from 'react'
import { Brain, Cpu, Database, Cloud, Code, Users, Bot, Wallet } from 'lucide-react'

const About = () => {
  const coreCompetencies = [
    { icon: Brain, label: 'AI/ML Solution Architecture', desc: 'MLOps & Production Systems' },
    { icon: Bot, label: 'Multi-Agent & Agentic AI', desc: 'CrewAI, Claude, Autonomous Systems' },
    { icon: Wallet, label: 'Cloud-Native Fintech', desc: 'End-to-End Infrastructure' },
    { icon: Users, label: 'Engineering Leadership', desc: '30+ Engineers' },
    { icon: Code, label: 'End-to-End Product Delivery', desc: 'Dev to Production' },
    { icon: Cpu, label: 'Cross-Functional Programs', desc: 'Technical Program Leadership' },
  ]
  
  return (
    <section id="about" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
            About <span className="text-gradient">Me</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Entrepreneurial operator who ships: from VC pitch through live cloud deployment.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-6">
            <p className="text-gray-300 text-lg leading-relaxed">
              Senior Engineering Leader with <span className="text-white font-semibold">19+ years</span> architecting and deploying AI/ML solutions, cloud-native fintech platforms, and multi-agent autonomous systems that drive measurable business outcomes.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              Proven track record building <span className="text-white font-semibold">production-grade AI pipelines</span> (fraud detection, NLP, ML forecasting), end-to-end fintech infrastructure, and agentic workflows using <span className="text-primary">CrewAI</span>, <span className="text-primary">Anthropic Claude</span>, and <span className="text-primary">Snowflake Cortex</span>.
            </p>
            <p className="text-gray-300 text-lg leading-relaxed">
              Expert in translating complex technical requirements into scalable intelligent systems achieving <span className="text-white font-semibold">99.99% uptime</span> while processing <span className="text-white font-semibold">1M+ monthly transactions</span>.
            </p>
            
            <div className="glass rounded-xl p-6 mt-8">
              <h4 className="font-display font-semibold text-white mb-4">Education & Certifications</h4>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2" />
                  <div>
                    <p className="text-white font-medium">Bachelor of Engineering, Computer Science</p>
                    <p className="text-gray-400 text-sm">PES Institute of Technology, Bangalore</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2" />
                  <div>
                    <p className="text-white font-medium">Project Management Professional (PMP)</p>
                    <p className="text-gray-400 text-sm">Project Management Institute</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-primary mt-2" />
                  <div>
                    <p className="text-white font-medium">Scrum Master Certified (SMC)</p>
                    <p className="text-gray-400 text-sm">Scrum Alliance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="font-display font-semibold text-white mb-6">Core Competencies</h4>
            <div className="grid grid-cols-2 gap-4">
              {coreCompetencies.map((item, index) => (
                <div key={index} className="glass rounded-xl p-4 hover:border-primary/50 transition-all group">
                  <item.icon className="w-8 h-8 text-primary mb-3 group-hover:scale-110 transition-transform" />
                  <h4 className="font-semibold text-white text-sm">{item.label}</h4>
                  <p className="text-gray-400 text-xs mt-1">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
